import Chart from 'chart.js/auto';
import CompareChartBase from './compare_chart_base';
import { t } from '../javascript/lib/i18n';

export default class extends CompareChartBase {
  get compareIds() {
    return new Set(
      this.chartDataValue.datasets.map((ds) => ds.compareId).filter(Boolean)
    );
  }

  initChart() {
    this.chart?.destroy();

    const ctx = this.canvasTarget.getContext('2d');
    const data = this.chartDataValue;
    const tickStep = data.axis?.tickStep ?? 1;

    const { gridColor, mutedColor } = this.chartTheme();

    this.chart = new Chart(ctx, {
      type: 'line',
      data: { labels: data.labels, datasets: data.datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              color: mutedColor,
              autoSkip: false,
              maxRotation: 0,
              callback: function (_value, index) {
                if (index % tickStep !== 0) return '';
                // Drop the trailing " HH:MM" so axis ticks read as dates.
                // Tooltips still receive the full label including the hour.
                return this.getLabelForValue(index).replace(
                  / \d{2}:\d{2}$/,
                  ''
                );
              },
            },
          },
          y: {
            type: 'linear',
            position: 'left',
            title: {
              display: true,
              text: t('js.charts.support_entries.entry_count'),
              color: mutedColor,
            },
            beginAtZero: true,
            grid: { color: gridColor },
            ticks: { precision: 0, color: mutedColor },
          },
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            titleColor: '#fff',
            bodyColor: '#fff',
            cornerRadius: 6,
            padding: 10,
            filter: (item) => item.raw !== 0 && item.raw !== null,
            callbacks: {
              label: (context) =>
                t('js.charts.support_entries.entries', {
                  label: context.dataset.label,
                  count: context.raw,
                }),
            },
          },
        },
      },
    });
  }

  paintChartColors() {
    this.chart.data.datasets.forEach((ds) => {
      if (!ds.compareId || ds.compareId === 'aggregate') return;
      const color = this.colorPool.get(ds.compareId);
      if (!color) return;
      ds.borderColor = color;
      ds.backgroundColor = color;
    });
  }
}
